export default import.meta.ROLLDOWN_FILE_URL_9kBTUqaINCHDANxrI10WCw